module.exports = "<div *ngIf=\"noSubjects\" class=\"mdl-cell mdl-cell--12-col mdl-cell-stretch\">\r\n    No subjects data available\r\n</div>"